import BigNumber from "bignumber.js";
// import { DECIMALS18 } from "../../market";

export const DECIMALS18 = new BigNumber(10).pow(18);
const SECONDS_PER_YEAR = 31536000;
const LN_2 = new BigNumber('693147180559945309'); // 0.693147180559945309
const MIN_EXP = DECIMALS18.times(-42);
const MAX_EXP = DECIMALS18.times(100);

export class SqrtTsAndPvs {
  exp2(x: BigNumber) {
    if (x.eq(0)) {
      return DECIMALS18;
    }
    if (x.gt(MAX_EXP)) {
      throw new Error('cannot handle exponents greater than 100');
    }

    let k = x.divEvm(LN_2);
    let p = new BigNumber(2).pow(k);
    let r = x.minus(k.times(LN_2));
    let t = DECIMALS18;
    let lastT = new BigNumber(0);
    for (let i = 16; i > 0; i--) {
      t = t.decimalMul(r.divEvm(i)).plus(DECIMALS18);
      if (t.eq(lastT)) {
        break;
      }
      lastT = t;
    }
    return p.times(t);
  }

  exp(x: BigNumber) {
    if (x.gte(0) ){
      return this.exp2(x);
    } else if (x.lt(MIN_EXP)) {
      // exp(-42) < 1e-18, so we just return 0
      return new BigNumber(0);
    } else {
      return DECIMALS18.decimalDiv(this.exp2(x.times(-1)));
    }
  }

  sqrt(x: BigNumber) {
    let z = x.plus(1).divEvm(2);
    let y = x;
    while (z.lt(y)) {
      y = z;
      z = x.divEvm(z).plus(z).divEvm(2);
    }
    return y;
  }

  getSqrtTsAndPvs(timestamp: number, expiry: number, rate: BigNumber) {
    const tAnnualised = expiry > timestamp ? new BigNumber(expiry - timestamp).decimalDiv(new BigNumber(SECONDS_PER_YEAR)) : new BigNumber(0);
    const s = this.sqrt(tAnnualised.times(DECIMALS18));
    const p = this.exp(rate.times(-1).decimalMul(tAnnualised));
    return [s, p];
  }
}
